import axios from 'axios';

export const requestPremiumPaymentIntent = (payload: any): Promise<any> => {
  return axios.post('v1/premium/web/purchases', payload.toJSON());
};
